import { default as BaseBreadcrumbs } from '@/components/Breadcrumbs';
import breadcrumbs from '@/modules/product/breadcrumbs';

const Breadcrumbs = () => <BaseBreadcrumbs breadcrumbs={breadcrumbs} />;

export default Breadcrumbs;
